<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-arrow-left-right"></i>
              Transferencia entre cajas
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">
            <div class="form-card__field">
              <label class="form-card__label" for="trans-to">Caja de destino</label>
              <q-select v-model="transfer.to_fund_id" :options="fundOptions" placeholder="- Seleccionar caja -" />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="trans-amount">Monto</label>
              <input id="trans-amount" v-model.number="transfer.amount" type="number" min="0" step="0.01" class="form-control" placeholder="0.00">
            </div>

            <div v-if="needsExchange" class="form-card__field">
              <label class="form-card__label" for="trans-exchange">Cotización</label>
              <input id="trans-exchange" v-model.number="dolarBlue" type="number" step="0.01" class="form-control" disabled>
              <div class="form-card__hint">Cotización del dólar blue (consultada automáticamente).</div>
            </div>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close">Cancelar</button>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!canSave || disabledSave"
              @click="saveTransfer()"
            >
              <i class="bi bi-check-lg"></i>
              Guardar transferencia
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: { QSelect },
  props: ["fundId"],
  data() {
    return {
      transfer: { to_fund_id: null, amount: null, dolar: 0 },
      funds: [],
      dolarBlue: null,
      fund: {},
      toFund: {},
      disabledSave: false,
    };
  },
  computed: {
    needsExchange() {
      return this.fund.currency
        && this.toFund.currency
        && this.fund.currency !== this.toFund.currency;
    },
    canSave() {
      return !!(this.transfer.to_fund_id && this.transfer.amount > 0);
    },
    fundOptions() {
      return this.funds.map(f => ({ value: f.id, label: f.name }));
    },
  },
  mounted() {
    this.getFunds();
    this.getDolarBlue();
    this.getFund();
  },
  methods: {
    getFunds() {
      this.$http.get("/api/funds/listSimple").then((response) => {
        this.funds = response.data.data.filter(c => c.id != this.fundId);
      });
    },
    getFund() {
      this.$http.get("/api/funds/getFund/" + this.fundId).then((response) => {
        this.fund = response.data.data;
      });
    },
    onToFundChanged() {
      const id = this.transfer.to_fund_id;
      if (id == null) {
        this.toFund = {};
        return;
      }
      this.$http.get("/api/funds/getFund/" + id).then((response) => {
        this.toFund = response.data.data;
      });
    },
    getDolarBlue() {
      fetch('https://api.bluelytics.com.ar/v2/latest')
        .then(response => response.json())
        .then(data => { this.dolarBlue = data.blue.value_sell; })
        .catch(() => { this.dolarBlue = null; });
    },
    saveTransfer() {
      if (!this.canSave) return;
      this.transfer.dolar = this.dolarBlue;
      this.disabledSave = true;
      this.$http.post("/api/funds/transfer/" + this.fundId, this.transfer)
        .then(() => {
          this.$emit("confirmsave");
          this.$emit('close');
        })
        .finally(() => { this.disabledSave = false; });
    },
    close() {
      this.$emit('close');
    },
  },
  watch: {
    'transfer.to_fund_id': function() {
      this.onToFundChanged();
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 24px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
